<nav class="accessibility-nav px-16">
  <div class="skip-links">
    <div class="px-4 py-2">
      <a (click)="pularPara('conteudo'); $event.preventDefault()">
        <span class="text-body-sm text-regular text-charcoal-800">Ir para o conteúdo 1</span>
      </a>
    </div>
    <div class="px-4 py-2">
      <a (click)="pularPara('menu2'); $event.preventDefault()">
        <span class="text-body-sm text-regular text-charcoal-800">Ir para o menu 2</span>
      </a>
    </div>
    <div class="px-4 py-2">
      <a (click)="pularPara('footer'); $event.preventDefault()">
        <span class="text-body-sm text-regular text-charcoal-800">Ir para o rodapé 3</span>
      </a>
    </div>
  </div>

  <div class="accessibility-controls">
    <div class="text-size-controls px-4 py-2">
      <span class="text-body-sm text-regular text-charcoal-800">Tamanho do Texto:</span>
      <button
        [disabled]="!podeAumentar()"
        [class.button-disabled]="!podeAumentar()"
        aria-label="Aumentar fonte"
        class="invisible-button"
        (click)="aumentarFonte()">
        <span class="text-body-lg text-regular text-charcoal-800">A+</span>
      </button>
      <button
        [disabled]="fontSizeLevel === 0"
        [class.button-disabled]="fontSizeLevel === 0"
        aria-label="Fonte padrão"
        class="invisible-button"
        (click)="resetarTamanhoFonte()">
        <span class="text-body-lg text-regular text-charcoal-800">A</span>
      </button>
      <button
        [disabled]="!podeDiminuir()"
        [class.button-disabled]="!podeDiminuir()"
        aria-label="Diminuir fonte"
        class="invisible-button"
        (click)="diminuirFonte()">
        <span class="text-body-lg text-regular text-charcoal-800">A-</span>
      </button>
    </div>

    <div class="right-options flex gap-8 px-4 py-2">
      <button
        aria-label="Alternar contraste"
        [attr.aria-pressed]="highContrast"
        class="invisible-button flex items-center gap-2"
        (click)="habilitarContraste()">
        <span class="text-body-sm text-regular text-charcoal-800">Contraste</span>
        <span class="contrast-icon">🌓</span>
      </button>

      <button
        *ngIf="isLoggedIn()"
        aria-label="logout"
        class="invisible-button flex items-center gap-2"
        title="admin&#64;simcaqvix.com.br&nbsp;"
        (click)="logout()">
        <span class="text-body-sm text-bold text-red-800">Logout</span>
      </button>

      <button
        *ngIf="!isLoggedIn()"
        aria-label="login"
        class="invisible-button flex items-center gap-2"
        (click)="login()">
        <span class="text-body-sm text-bold text-blue-800">Login</span>
      </button>
    </div>
  </div>
</nav>
